import {
  bestMixedWasteColumns,
  worstMixedWasteColumns,
} from "@/Utils/tableColumns/performanceColumns";
import { EmptyView } from "@/components/EmptyView/EmptyView";
import PerformanceRate from "@/components/PerformanceRate";
import { Card, CardComponentFilterLocation } from "@/components/pageCards/card";
import { useTrans } from "@/translations";

import { mixedWastePerformance } from "../functions/dataHandling";
import { usePerformance } from "../hooks/usePerformance";

export const MixedWastePerformance = () => {
  const { t } = useTrans();
  const {
    filters,
    firstPeriod,
    currentPeriod,
    isLoading,
    isError,
    setActiveOptions,
    accessCodes,
  } = usePerformance();

  const mixedWastePerformanceData =
    !firstPeriod || !currentPeriod
      ? []
      : mixedWastePerformance(currentPeriod, firstPeriod, accessCodes);

  return (
    <Card
      title={"statisticsLabels:mixedWastePerformance"}
      filters={filters}
      onFilterOptionChange={setActiveOptions}
      filterLocation={CardComponentFilterLocation.RIGHT}
    >
      {isError ? (
        <EmptyView type="failToFetch" className="min-h-[300px]" />
      ) : (
        <PerformanceRate
          data={mixedWastePerformanceData.filter((el) => el.rate !== 0)}
          isLoading={isLoading}
          sort="desc"
          bestColumns={bestMixedWasteColumns}
          worstColumns={worstMixedWasteColumns}
          bestHeading={t("statisticsLabels:leastMixedWasteHeading")}
          bestCaption={t("hints:leastMixedWasteCaption")}
          worstHeading={t("statisticsLabels:mostMixedWasteHeading")}
          worstCaption={t("hints:mostMixedWasteCaption")}
        />
      )}
    </Card>
  );
};
